import { ArrowDownIcon, ArrowUpIcon, Heading2Icon, LightbulbIcon, ListIcon, PilcrowIcon, XIcon } from 'lucide-react';
import { btnIcon } from '../ui/styles';
import { AutoTextarea } from '../ui/AutoTextarea';
import type { ArticleBlock } from '../../core/types/content';
export const blockTypes: {
  type: ArticleBlock['type'];
  label: string;
  icon: typeof PilcrowIcon;
}[] = [{
  type: 'p',
  label: 'Alinea',
  icon: PilcrowIcon
}, {
  type: 'h',
  label: 'Tussenkop',
  icon: Heading2Icon
}, {
  type: 'list',
  label: 'Opsomming',
  icon: ListIcon
}, {
  type: 'tip',
  label: 'Tip van Sarah',
  icon: LightbulbIcon
}];
export const newBlock = (type: ArticleBlock['type']): ArticleBlock => type === 'list' ? {
  type,
  items: ['']
} : {
  type,
  text: ''
};
type Props = {
  block: ArticleBlock;
  position: number;
  total: number;
  onChange: (block: ArticleBlock) => void;
  onMove: (dir: -1 | 1) => void;
  onRemove: () => void;
};

/** Eén blok in de artikeltekst, met verplaatsen en weghalen. */
export function ArticleBlockRow({
  block,
  position,
  total,
  onChange,
  onMove,
  onRemove
}: Props) {
  const meta = blockTypes.find(b => b.type === block.type) ?? blockTypes[0];
  const name = `${meta.label} ${position} van ${total}`;
  return <li className="rounded-md bg-shell" data-id="element-559" data-mp="3dm5mbaye92bg">
      <div className="flex items-center justify-between gap-2 border-b border-line px-3 py-1.5" data-id="element-560" data-mp="3dn70vpemc6xx">
        <span className="flex items-center gap-1.5 text-[12px] text-muted" data-id="element-561" data-mp="3il8s4xm77ckh">
          <meta.icon className="h-3.5 w-3.5" strokeWidth={1.75} aria-hidden="true" data-id="element-562" data-mp="a5yin4fzb52o" />
          {meta.label}
        </span>
        <span className="flex items-center" data-id="element-563" data-mp="f3gw984xy8h0">
          <button type="button" onClick={() => onMove(-1)} disabled={position === 1} aria-label={`${name} omhoog`} className={btnIcon} data-id="element-564" data-mp="fdn5pvlqgnz">
            <ArrowUpIcon className="h-3.5 w-3.5" strokeWidth={1.75} aria-hidden="true" data-id="element-565" data-mp="5cvzlq8tve0q" />
          </button>
          <button type="button" onClick={() => onMove(1)} disabled={position === total} aria-label={`${name} omlaag`} className={btnIcon} data-id="element-566" data-mp="t2zth5w7rzej">
            <ArrowDownIcon className="h-3.5 w-3.5" strokeWidth={1.75} aria-hidden="true" data-id="element-567" data-mp="xwcbgx6e17yb" />
          </button>
          <button type="button" onClick={onRemove} aria-label={`${name} verwijderen`} className={btnIcon} data-id="element-568" data-mp="12rdntab48q91">
            <XIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-569" data-mp="ypjvbpb2qsjy" />
          </button>
        </span>
      </div>
      <div className="p-3" data-id="element-570" data-mp="tpnntg364izn">
        {block.type === 'list' ? <AutoTextarea value={block.items.join('\n')} onChange={e => onChange({
        type: 'list',
        items: e.target.value.split('\n')
      })} minRows={3} placeholder="Eén punt per regel" className="w-full bg-transparent text-[16px] leading-relaxed text-ink focus:outline-none sm:text-[15px]" aria-label={`${name}, één punt per regel`} data-id="element-571" data-mp="orm8954yb1sx" /> : <AutoTextarea value={block.text} onChange={e => onChange({
        ...block,
        text: e.target.value
      })} minRows={block.type === 'h' ? 1 : 2} placeholder={block.type === 'h' ? 'Tussenkop' : block.type === 'tip' ? 'Je tip…' : 'Schrijf hier…'} aria-label={name} className={`w-full bg-transparent text-ink focus:outline-none ${block.type === 'h' ? 'font-display text-[20px]' : block.type === 'tip' ? 'text-[16px] italic leading-relaxed sm:text-[15px]' : 'text-[16px] leading-relaxed sm:text-[15px]'}`} data-id="element-572" data-mp="61e8mx0gmthh" />}
      </div>
    </li>;
}